export function findPageLinkEnd(
	value: string,
	start: number,
	includeClosingBrackets = false
): number {
	let index = start;

	while (index < value.length) {
		const current = value[index];
		if (current === "\n" || current === "\r") {
			return -1;
		}

		if (current === "\\") {
			index += 2;
			continue;
		}

		if (current === "]" && value[index + 1] === "]") {
			return includeClosingBrackets ? index + 2 : index;
		}

		index += 1;
	}

	return -1;
}
